import moment from 'moment'
import React, { useEffect } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import Layout from '../../Layout'

export default function TeamLeaseDumpReport() {
  const { downloadLoading, pdfCsvData, getTeamLeaseDumpReport } = useAttendance()

  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = React.useState(startDate)
  const [to, setTo] = React.useState(new Date())

  useEffect(() => {
    getTeamLeaseDumpReport({ from: moment(from).add(330, 'minutes').toISOString(), to: to })
  }, [from, to])

  return (
    <Layout
      heading="Team Lease Dump Report"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      filename="team-lease_dump_report"
      downloadLoading={downloadLoading}
      headers={pdfCsvData.headings}
      data={pdfCsvData.headingValues}
    >
      <div style={{ fontSize: '20px', textAlign: 'center', marginTop: '10px', opacity: '0.8' }}>Click On Download Button to Download</div>
    </Layout>
  )
}
